import React from "react";
import type { ReactNode } from "react";
import { useAuth } from "tecrmi_components/useAuth";
import { setGlobalAccessTokenFn } from "@utils/httpClient";
import { setReleaseNotesAccessTokenFn } from "@services/releaseNotesApi";
import { LoadingScreen } from "@xplatform/design-system";

interface Props {
  children: ReactNode;
}

export const ModuleContextProvider: React.FC<Props> = ({ children }) => {
  const { getValidAccessToken, currentSession, loading } = useAuth();
  const [tokenReady, setTokenReady] = React.useState(false);

  React.useEffect(() => {
    setGlobalAccessTokenFn(getValidAccessToken);
    setReleaseNotesAccessTokenFn(getValidAccessToken);
  }, [getValidAccessToken]);

  React.useEffect(() => {
    const storeToken = async () => {
      const token = await getValidAccessToken();
      if (token) {
        localStorage.setItem("accessToken", token);
        setTokenReady(true);
      }
    };
    if (currentSession) {
      storeToken();
    } else {
      localStorage.removeItem("accessToken");
      setTokenReady(false);
    }
  }, [currentSession, getValidAccessToken]);

  if (loading || (currentSession && !tokenReady)) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  return <>{children}</>;
};
